import { actionCreatorFactory } from "typescript-fsa";

import { AssigneeCandidate } from "../../app/slices/users/types";

const factory = actionCreatorFactory("MODULF");
export const assignProcessDocument = factory<AssignProcessDocumentPayload>("ASSIGN_PROCESS_DOCUMENT");

export interface AssignProcessDocumentPayload {
	readonly docRef: string;
	readonly activityId: string;
	readonly assignee: string | null;
	readonly assigneeHtmlRef?: HTMLElement;
}

export const showProcessAssignmentModal = factory<ShowAssignmentModalPayload>("SHOW_ASSIGNMENT_MODAL");

export interface ShowAssignmentModalPayload {
	readonly activityId: string;
}

export const assignWiedervorlageDocument = factory<AssignWiedervorlageDocumentPayload>("ASSIGN_WIEDERVORLAGE_DOCUMENT");

export interface AssignWiedervorlageDocumentPayload {
	readonly docRef: string;
	readonly activityId: string;
	readonly assignee?: AssigneeCandidate | null;
}

export const assignStammdatenDocument = factory<AssignStammdatenDocumentPayload>("ASSIGN_STAMMDATEN_DOCUMENT");

export interface AssignStammdatenDocumentPayload {
	readonly docRef: string;
	readonly activityId: string;
	readonly assignee?: AssigneeCandidate | null;
}
